/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_What_P3Inputs */

const en_wc_what_p3 = /** @type {(inputs: Wc_What_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To try WordCraft before installing it, load the editor above and choose Blank document or open a local file. You can format text, add a table and save a copy to your device. The beginner tutorial explains each step; no site account is required.`)
};

/**
* | output |
* | --- |
* | "To try WordCraft before installing it, load the editor above and choose Blank document or open a local file. You can format text, add a table and save a copy..." |
*
* @param {Wc_What_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_what_p3 = /** @type {((inputs?: Wc_What_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_What_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_what_p3(inputs)
});
export { wc_what_p3 as "wc.what.p3" }